module.exports = __webpack_public_path__ + "media/images/lig/flatlay-04-e15bca701326e2b7cd429d47b5043a6d.png";